export default function CheckIcon() {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.3287 3.77778C12.9548 2.66596 11.2052 2 9.29999 2C4.88171 2 1.29999 5.58172 1.29999 10C1.29999 14.4183 4.88171 18 9.29999 18C13.7183 18 17.3 14.4183 17.3 10C17.3 9.59482 17.2699 9.19668 17.2118 8.80769" stroke="#005EFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M5.74432 9.11103L9.29987 12.6666L18.6332 3.33325" stroke="#005EFF" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
    );
}